import React, { useEffect, useRef, forwardRef } from "react";
import { components } from "react-select";

export const MenuList = forwardRef(
  ({ fetchMoreData, fetchPreviousData, ...props }, ref) => {
    const menuListRef = useRef(null);

    const handleScroll = (event) => {
      const target = event.target;
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        fetchMoreData();
      } else if (target.scrollTop === 0) {
        fetchPreviousData();
      }
    };

    useEffect(() => {
      const currentRef = ref?.current || menuListRef.current;
      if (currentRef) {
        currentRef.addEventListener("scroll", handleScroll);
      }

      return () => {
        if (currentRef) {
          currentRef.removeEventListener("scroll", handleScroll);
        }
      };
    }, [ref]);

    return <components.MenuList {...props} innerRef={ref || menuListRef} />;
  }
);
